/**
 * @file 嗅探手机按照app列表
 * @author sunshijie
 */
/* global App, getApp, Page, Component, Behavior, swan, getCurrentPages, requireDynamicLib */

import { compareVersion } from './prefetch-utils';
import { APP_PACKAGES_NAME, APP_SCHEMA_NAME } from './appNames';
import { bigInt } from './BigInteger.min';
/**
 * 嗅探APP列表结果
 */

export const getAppInstalled = function (params = {}) {
  const callback = typeof params.callback === 'function' ? params.callback : '';
  let app = getApp();
  let iadlist = 0;

  // 如globalData内有则直接使用
  if (app.globalData.iadlist) {
    let resObj = {
      iadlist: app.globalData.iadlist
    };
    callback && callback(resObj);
  } else if (app.globalData.SDKVersion && compareVersion(app.globalData.SDKVersion, '3.260.27') > 0) {
    // 如globalData没有则使用小程序接口能力获取
    // 商业嗅探，功能仅支持3.260.27及以上版本
    let appList = Object.keys(APP_PACKAGES_NAME);
    let iadListData = APP_PACKAGES_NAME;
    if (app.globalData.system && app.globalData.system.toLowerCase().indexOf('ios') > -1) {
      appList = Object.keys(APP_SCHEMA_NAME);
      iadListData = APP_SCHEMA_NAME;
    }
    let posList = [];
    appList.length && getApp().$api.isAppInstalled && getApp().$api.isAppInstalled({
      name: appList,
      success(res) {
        res = res || {};
        for (let appName in res) {
          if (res[appName]) {
            let pos = iadListData[appName];
            posList.push(pos);
          }
        }
        iadlist = posList.reduce((iadlist, pos) => {
          return iadlist.or(bigInt(1).shiftLeft(pos - 1));
        }, bigInt(1)).value.toString();
        let resObj = {
          iadlist: iadlist
        };
        // 将结果放入globalData
        app.globalData = {
          ...(app.globalData || {}),
          ...(resObj || {})
        };
        callback && callback(resObj);
      },
      fail() {
        callback && callback({
          iadlist: 0
        });
      }
    });
  } else {
    callback && callback({
      iadlist: 0
    });
  }
};